'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _HolderOutlined = _interopRequireDefault(require('./lib/icons/HolderOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _HolderOutlined;
exports.default = _default;
module.exports = _default;